import { clearCachedMyUser } from 'session/myUserCache';

// Logs out through the site header's logout form: clears the user data this
// browser and the service worker cache, drops this browser's push subscription, and posts the
// form. Also used by the logout action (react/redux/actions/user).
export function logout(form = document.getElementById('logout_form')) {
	if(!form) {
		return;
	}
	clearCachedMyUser();
	if(typeof window.messageServiceWorker === 'function') {
		window.messageServiceWorker({ action: 'clearCachedUserData' });
	}
	if(navigator.serviceWorker && window.serviceWorkerLocation) {
		navigator.serviceWorker.register(window.serviceWorkerLocation)
			.then((registration) => (registration.pushManager ? registration.pushManager.getSubscription() : null))
			.then((subscription) => (subscription ? subscription.unsubscribe() : null))
			.catch((error) => console.log(error));
	}
	form.submit();
}
